import clsx from 'clsx';
export const cn = clsx;
//# sourceMappingURL=cn.js.map